// Native iOS push glue — talks to the Capacitor bridge injected by the myPandaX
// iOS shell. Every function is a safe no-op in regular browsers.
import { api } from "@/lib/api";

const plugin = () => window.Capacitor?.Plugins?.PushNotifications;

export function isNativeIOS() {
  try {
    return !!(window.Capacitor?.isNativePlatform?.() && window.Capacitor?.getPlatform?.() === "ios");
  } catch {
    return false;
  }
}

let bound = false;

export async function initNativePush() {
  const P = plugin();
  if (!isNativeIOS() || !P || bound) return;
  bound = true;
  await P.addListener("registration", async ({ value }) => {
    try {
      await api.post("/push/ios/register", { token: value });
    } catch (e) {
      console.warn("[push][ios] token register failed:", e?.message);
    }
  });
  await P.addListener("pushNotificationActionPerformed", ({ notification }) => {
    const url = notification?.data?.url;
    if (typeof url === "string" && url.startsWith("/")) window.location.assign(url);
  });
  try {
    const perm = await P.checkPermissions();
    if (perm.receive === "granted") await P.register();
  } catch { /* silent */ }
}

export async function enableNativePush() {
  const P = plugin();
  if (!P) return { ok: false, reason: "unsupported" };
  await initNativePush();
  let perm = await P.checkPermissions();
  if (perm.receive === "prompt") perm = await P.requestPermissions();
  if (perm.receive !== "granted") return { ok: false, reason: "permission" };
  await P.register();
  return { ok: true };
}

export async function disableNativePush() {
  try {
    await api.post("/push/ios/unregister");
  } catch { /* server-side cleanup is best-effort */ }
  return { ok: true };
}

export async function nativePushGranted() {
  const P = plugin();
  if (!P) return false;
  try {
    return (await P.checkPermissions()).receive === "granted";
  } catch {
    return false;
  }
}
